import { UsernameRenameWidgetData } from './types';
import { NetworkRequestState } from '../baseTypes';

export const defaultUsernameRenameWidgetData: UsernameRenameWidgetData['initialData'] =
  {
    username: '',
    password: '',
    isRenameEligible: false,
    hasRecentRename: false,
  };
export const defaultUsernameRenameWidgetState: UsernameRenameWidgetData = {
  initialData: defaultUsernameRenameWidgetData,
  currentData: defaultUsernameRenameWidgetData,
  isDirty: false,
  saveRequest: {
    status: NetworkRequestState.IDLE,
  },
};
